const VERSION = 'v1.4.3';

export default VERSION;



// WEBPACK FOOTER //
// ./src/config/version.js